<template>
  <segment title="Other Settings" collapsable>
    <div>
      <div class="row">
        <i class="fas fa-info-circle" @mouseover="displayInfo('message-info-additional')" @mouseleave="removeInfo('message-info-additional')" style="margin: auto 1rem;" ></i> 
        <expandable-options title="Additional Data" label="Field" v-model="additionalData" :structure="additionalDataStructure" />
      </div>
      <div class="info" id="message-info-additional">
        <pre>
         Use this section if you want to attach additional data in your push message.
         You can attach multiple key-value pairs to transfer data via your notifications. 
         You can use this section to open a specific page on the app after the user taps the message
        </pre>
      </div>
    <div class="row">
      <i class="fas fa-info-circle" @mouseover="displayInfo('message-info-ttl')" @mouseleave="removeInfo('message-info-ttl')" style="margin: auto 1rem;"></i> 
      <input-group placeholder="In hours (72 hour)" label="Time To Live" value-type="number" inline v-model="timeToLive" :min="0" />
    </div>
    <div class="info" id="message-info-ttl">
      <pre>
          This tells the system how long to retry sending a notification if the previous tries failed for some reason. 
          Default value is 72 hours. 
      </pre>
    </div>
    <div style="display: flex; align-items: center;">
      <a target="_blank" href="https://developer.apple.com/documentation/usernotifications/declaring_your_actionable_notification_types" style="margin-right: 15px;">
        <i class="fas fa-info-circle" />
      </a>
      <input-group placeholder="Category" label="Category (Action Buttons)" inline v-model="category" />
    </div>
    </div>
  </segment>
</template>

<script>
import ExpandableOptions from "@/views/PushNotification/UIComponents/ExpandableOptions";
import InputGroup from "@/views/PushNotification/UIComponents/InputGroup";
import Segment from "@/views/PushNotification/UIComponents/Segment";
import {displayMixin} from "@/util/displayMixin.js"
export default {
  name: "OtherSettings",
  mixins: [displayMixin],
  components: {
    InputGroup,
    ExpandableOptions,
    Segment
  },
  model: {
    prop: "modelProp",
    event: "modelEvent"
  },
  props: {
    modelProp: Object
  },
  data() {
    return {
      additionalDataStructure: {
        keys: ["key", "value"],
        placeholder: ["Key", "Value"]
      }
    }
  },
  computed: {
    additionalData: {
      get() {
        return this.modelProp.additionalData;
      },
      set(value) {
        this.$emit('modelEvent', { ...this.modelProp, additionalData: value });
      }
    },
    timeToLive: {
      get() {
        return this.modelProp.timeToLive;
      },
      set(value) {
        this.$emit('modelEvent', { ...this.modelProp, timeToLive: value });
      }
    },
    category: {
      get() {
        return this.modelProp.category;
      },
      set(value) {
        this.$emit('modelEvent', { ...this.modelProp, category: value });
      }
    }
  },
  methods:{

  }
}
</script>

<style scoped>

</style>